import axios from 'axios';

function getToken() {
    const m = document.cookie.match(/(?:^|;\s*)token=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : '';
}

function tokenQs(extra = '') {
    return '?token=' + encodeURIComponent(getToken()) + (extra ? '&' + extra : '');
}

/**
 * 发送一条消息。
 * @param {Array<{role: string, content: string}>} messages 完整历史（最后一条是新发送的用户消息）
 * @param {?number} conversationId 已有会话 ID；null 时后端会新建
 * @returns {Promise<{reply: string, tool_trace: Array, conversation_id: number}>}
 */
export async function sendBotChat(messages, conversationId = null) {
    const res = await axios.post(window.api + 'bot/chat' + tokenQs(), {
        messages,
        conversation_id: conversationId,
    });
    return res.data;
}

/** 当前用户的会话列表 */
export async function listConversations() {
    const res = await axios.get(window.api + 'bot/conversations' + tokenQs());
    return res.data.rows || [];
}

/** 单个会话的历史消息 */
export async function loadConversation(id) {
    const res = await axios.get(window.api + 'bot/conversations/' + id + tokenQs());
    return res.data; // { conversation, messages }
}

/** 删除某会话 */
export async function deleteConversation(id) {
    await axios.delete(window.api + 'bot/conversations/' + id + tokenQs());
}
